import moment from "moment";
import { createSelector } from "reselect";
import { PAGINATION } from '../constant';

export const sortDate = (type) => {
    if (type === 'Today') return 0
    else if (type === 'Tomorrow') return 1
    else if (type === 'Yesterday') return 2
    else if (type === 'This Week') return 3
    else if (type === 'This Month') return 4
    else if (type === 'Upcoming') return 5
    else if (type === 'No Due Date') return 6
    else if (type === 'Older') return 7
}

export const getItemStyle = (isDragging, draggableStyle) => {
    return {
        background: isDragging ? "#f5f6fa" : '',
        ...draggableStyle
    };
};

export const getTaskListStyle = isDraggingOver => ({
    background: isDraggingOver ? "#f5f6fa" : "",
});

export const normalizeOptions = (options) => (
    Array.isArray(options)
        ? options.map(option => ({
            label: option?.label ?? option?.name ?? option?.value ?? option,
            value: option?.value ?? option?._id ?? option,
        }))
        : options
);

export const normalizeFields = (fields, default_option, includeExtraFields = true) => {
    if (!Array.isArray(fields) || !fields.length) {
        return default_option;
    }

    const normalized = fields.map(field => ({
        ...field,
        options: normalizeOptions(field?.options)
    }));

    return [
        ...normalized,
        {
            name: "Reason To Change Note",
            value: "reasonToChangeNote",
            type: 11,
            status: 2,
            sectionType: 2,
            isDefault: false,
            sortOrder: 0
        }
    ];
};

export const resolveCountryId = (country) => (
    typeof country === "object" ? country?.value : country
);

export const unreadCounter = (array, module, type) => {
    return array.filter(a => module.includes(a?.referenceType))?.find(e => type === 'my' ? e?.myUnRead?.isUnRead : type === 'employee' ? e?.employeeUnRead?.isUnRead : e?.isUnRead)
}

export const updateUnReadCount = (message, messageList) => {
    return messageList.map((m, i) => {
        if (m?._id === message.referenceId) m.unreadCount = message.unreadCount || 0
        return m
    })
}

const requestTrackerData = new Map();
const isDuplicateRequestData = (event, data) => {
    const requestKey = JSON.stringify({ event, data });
    if (requestTrackerData?.has(requestKey)) return true;
    requestTrackerData?.set(requestKey, true);
    setTimeout(() => {
        if(requestTrackerData instanceof Map) requestTrackerData?.delete(requestKey);
    }, 1000); // Adjust timeout based on the expected time for requests to complete
    return false;
};

/**
 * Recursively finds values of the given keys in deeply nested data structures
 * and returns a unique array of truthy values.
 *
 * @param {any} data - The data to search through (any valid JavaScript data type).
 * @param {string[]} keys - An array of keys to find in the data.
 * @returns {Array} - An array of unique truthy values found for the keys.
 */
export function findUserFunction(data, keys=[],DISPATCH = ()=> {},event) {
    // Check if the first parameter is valid
    if (typeof data === 'undefined' || data === null) {
        return null;
    }

    // Ensure the second parameter is an array of strings
    if (!Array.isArray(keys) || !keys.every(key => typeof key === 'string')) {
        return null;
    }

    keys = ["createdBy", "updatedBy", "user", "userId", "actionBy"]?.concat(keys);
    const uniqueValues = new Set();

    function search(value) {
        if (Array.isArray(value)) {
            // Iterate over array elements
            value.forEach(item => search(item));
        } else if (value && typeof value === 'object') {
            // Iterate over object properties
            Object.entries(value).forEach(([key, val]) => {
                if (keys.includes(key) && val && /^[a-f0-9]{24}$/?.test(val) && typeof val === 'string' && val !== "_id") {
                    uniqueValues.add(val); // Add only truthy values
                }
                search(val); // Recursively search nested structures
            });
        }
    }

    // Start the search
    search(data);
    if (isDuplicateRequestData(event, Array.from(uniqueValues))) return null;
    if (uniqueValues?.size > 0) {
        DISPATCH({type: 'FIND_MASTER_DATA_LIST', payload: {findUserIdsList: Array.from(uniqueValues)}});
    }
    return null;
}

export const getGradeOptions = (allValues, gradeList, jobTitleList) => {
    if (!Array.isArray(gradeList)) return [];

    const jobTitle = allValues?.jobTitle?.value ?? allValues?.jobTitle;
    const bands = allValues?.bands?.value ?? allValues?.bands;

    if(!jobTitle && !bands) return gradeList
      if (bands) {
        const filteredList = gradeList.filter(e => e.bands?.includes(allValues.bands));
        return filteredList.length ? filteredList : gradeList.filter(e => !e.bands?.length);
    } else if (jobTitle) {
        const selectedJob = jobTitleList?.find(job => job?.value === jobTitle);
        return gradeList.filter(e => selectedJob?.bands ? e.bands?.includes(selectedJob.bands) : !e?.bands?.length);
    }
};

export const getBandsOptions = (allValues, bandList, jobTitleList) => {
    if (!Array.isArray(bandList)) return [];

    const jobTitle = allValues?.jobTitle?.value ?? allValues?.jobTitle;
    const grade = allValues?.grade?.value ?? allValues?.grade;
    if(!jobTitle && !grade) return bandList

    if (grade) {
        const filteredBands = bandList.filter(e => e.grade === grade);
        return filteredBands.length ? filteredBands : bandList.filter(e => !e.grade && (!jobTitle || !e?.jobTitle?.length));
    } else if (jobTitle) {
        const selectedJobBands = jobTitleList?.find(job => job.value === jobTitle)?.bands;
        return bandList.filter(e => selectedJobBands ? e.value === selectedJobBands : !e.jobTitle?.length);
    }

    return bandList;
};

export const getJobTitleOptions = (allValues, jobTitleList) => {
    if (!jobTitleList) return [];
    const bands = allValues?.bands?.value ?? allValues?.bands;

    if (!bands) return jobTitleList;

    const filtered = jobTitleList.filter(e => e.bands === bands);
    return filtered.length ? filtered : jobTitleList?.filter(e => !e?.bands);
};

export const filterRangeObj = (date, filterName = 'Date') => {
    let filterStartDate = date?.startDate ? moment(date?.startDate).format('D MMM YY') : `Select ${filterName}`;
    let filterEndDate = date?.endDate ? moment(date?.endDate).format('D MMM YY') : `Select ${filterName}`;

    filterEndDate = filterStartDate === filterEndDate ? '' : ` - ${filterEndDate}`;

    return date.length !== 0 ? `${filterName}: ${filterStartDate}${filterEndDate}` : `${filterName}`;
}

export const getMonthlySalary = (amount, type) => {
    if(type === 1){ // For  yearly Salary
        return parseFloat( Number(amount)/12);
    }else {
        return parseFloat(amount) || 0;
    }
}

export const handleGradeAndBandsLogic = (e, name, _GRADE) => {

    const payload = {
        [name]: e,
        currentPage: PAGINATION.CURRENT_PAGE
    };
    const selectedGradeId = e?.[0]?.grade;
    const matchedGrade = _GRADE.find(grade => grade._id === selectedGradeId);

    if (matchedGrade) {
        payload.grade = matchedGrade;
    }
    // Clear bands if grade is cleared
    if (name === 'grade' && !e) {
        payload.bands = null;
    }
    if (name === 'bands' && !e) {
        payload.bands = null;
    }
    if (name === 'grade' && e) {
        payload.bands = null;
    }
    // Clear grade if bands is cleared
    if (name === 'bands' && !e?.length) {
        payload.grade = null;
    }
    return payload;
};

export const getInvalidPlaceholders = (content, validPlaceholders) => {
    if (!content) return [];
    const errors = [];

    // Check for incomplete placeholders like {{xyz or {{xyz} (missing closing }})
    const incompleteStart = content.match(/{{[^{}]*}(?!})|{{[^{}]*$/g);
    if (incompleteStart) {
        errors.push(...incompleteStart);
    }

    // Check for patterns missing the first { like {xyz}}
    const incompleteEndMatches = content.matchAll(/(?:^|[^{])({[^{}]*}})/g);
    for (const match of incompleteEndMatches) {
        errors.push(match[1]);
    }

    const matches = content.match(/{{([^{}]*)}}/g);
    if (matches) {
        for (const match of matches) {
            const key = match.replace(/{{|}}/g, '').trim();
            if (!validPlaceholders.includes(key)) {
                errors.push(match);
            }
        }
    }
    return [...new Set(errors)];
}

export const tagsList = {
    tagsForCandidateList: () => createSelector(
        state => state.ats.tagsForCandidateList ?? [],
        (tagsForCandidateList) => {
            const tags = []
            if (tagsForCandidateList?.length !== 0) tagsForCandidateList.forEach(t => tags.push({label: t.name, value: t._id, ...t}))
            return tags
        }
    ),
    tagsForJobList: () => createSelector(
        state => state.ats.tagsForJobList ?? [],
        (tagsForJobList) => {
            const tags = []
            if (tagsForJobList?.length !== 0) tagsForJobList.forEach(t => tags.push({label: t.name, value: t._id, ...t}))
            return tags
        }
    )
}

export const pipeLineTemplateList = () => createSelector(
    state => state.ats.pipeLineTemplateList ?? [],
    (pipeLineTemplateList) => {
        const list = []
        if (pipeLineTemplateList?.length !== 0) pipeLineTemplateList.forEach(t => list.push({label: t.name, value: t._id, ...t}))
        return list
    }
)

export const jobTemplateList = {
    withDraft: () => createSelector(
        state => state.ats.jobTemplateList ?? [],
        (jobTemplateList) => {
            const list = []
            if (jobTemplateList?.length !== 0) jobTemplateList?.forEach(t => list.push({label: t.name, value: t._id, ...t}))
            return list
        }
    ),
    withOutDraft: () => createSelector(
        state => state.ats.jobTemplateList ?? [],
        (jobTemplateList) => {
            const list = []
            if (jobTemplateList?.length !== 0) jobTemplateList?.filter(j => !j?.isDraft)?.forEach(t => list.push({label: t.name, value: t._id, ...t}))
            return list
        }
    ),
}
